(function ($) {
  'use strict';

  const cfg = window.FREE_GIFT_CONFIG || {};


  /* =========================
     HELPERS
  ========================= */
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(0);
  }

  /* =========================
     PRELOADER
  ========================= */
  $(window).on('load', function () {
    $('#preloder').fadeOut();
  });

  /* =========================
     SET BACKGROUND IMAGES
  ========================= */
  $('.set-bg').each(function () {
    const bg = $(this).data('setbg');
    if (bg) {
      $(this).css('background-image', 'url(' + bg + ')');
    }
  });

  /* =========================
     OFFCANVAS MENU
  ========================= */
  $('.canvas__open').on('click', function () {
    $('.offcanvas-menu-wrapper, .offcanvas-menu-overlay').addClass('active');
  });

  $('.offcanvas__close, .offcanvas-menu-overlay').on('click', function () {
    $('.offcanvas-menu-wrapper, .offcanvas-menu-overlay').removeClass('active');
  });

  /* =========================
     SLICKNAV
  ========================= */
  if ($.fn.slicknav) {
    $('.header__menu').slicknav({
      prependTo: '#mobile-menu-wrap',
      label: '',
      allowParentLinks: false,
      closedSymbol: '▸',
      openedSymbol: '▾',
      duration: 300
    });
  }

  /* =========================
     MIXITUP
  ========================= */
  if (typeof mixitup !== 'undefined') {
    const container = document.querySelector('.property__gallery');
    if (container) mixitup(container);
  }

/* =========================
   PRODUCT SLIDER
========================= */
function initProductSlider() {
  const $slider = $('.product__details__pic__slider');

  if (!$slider.length || $slider.hasClass('owl-loaded')) return;

  $slider.owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: false,
    smartSpeed: 600,
    mouseDrag: false,
    navText: [
      "<i class='arrow_carrot-left'></i>",
      "<i class='arrow_carrot-right'></i>"
    ]
  });
}

initProductSlider();


/* =========================
   PRODUCT THUMBNAILS
========================= */
$(document).on('click', '.product__details__pic__left .pt', function(e) {
  e.preventDefault();

  const $thumb = $(this);
  const index = parseInt($thumb.attr('data-index'), 10);
  const $slider = $('.product__details__pic__slider');

  if (!$slider.length || isNaN(index)) return;

  // Cambiar imagen principal
  $slider.trigger('to.owl.carousel', [index, 600, true]);

  // Cambiar miniatura activa
  $('.product__details__pic__left .pt').removeClass('active');
  $thumb.addClass('active');
});


/* =========================
   SYNC THUMBNAILS WITH SLIDER
========================= */
$(document).on(
  'changed.owl.carousel',
  '.product__details__pic__slider',
  function(event) {

    if (!event.item) return;

    const index = event.item.index;

    $('.product__details__pic__left .pt')
      .removeClass('active')
      .eq(index)
      .addClass('active');
  }
);

  /* =========================
     COUNTDOWN
  ========================= */
  function initCountdown(scope) {
    $('[data-countdown]', scope || document).each(function () {
      const $el = $(this);
      if ($el.data('init')) return;
      $el.data('init', true);

      const end = parseInt($el.data('countdown'), 10) * 1000;
      if (!end) return;

      function tick() {
        const d = end - Date.now();
        if (d <= 0) return;

        $el.find('.days').text(String(Math.floor(d / 86400000)).padStart(2, '0'));
        $el.find('.hours').text(String(Math.floor(d / 3600000) % 24).padStart(2, '0'));
        $el.find('.minutes').text(String(Math.floor(d / 60000) % 60).padStart(2, '0'));
        $el.find('.seconds').text(String(Math.floor(d / 1000) % 60).padStart(2, '0'));
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  $(document).ready(() => initCountdown(document));
  document.addEventListener('shopify:section:load', e => initCountdown(e.target));

 /* =========================
     FLYING CART
========================= */
const $cart = $('#flying-cart');
const $overlay = $('#flying-cart-overlay');
const $content = $('.flying-cart__content');
const $subtotal = $('#flying-cart-subtotal');
const $cartCount = $('.cart-count');

let cartState = null;
let syncing = false;

/* =========================
   CROSS PROMO CONFIG
========================= */
const CROSS_PROMO = window.CROSS_PROMO || {
  enabled: false,
  triggerId: 0,
  conditionalIds: [],
  discount: 0
};

function openCart() {
  $cart.addClass('active');
  $overlay.addClass('active');
}

function closeCart() {
  $cart.removeClass('active');
  $overlay.removeClass('active');
}

/* =========================
   RENDER CART
========================= */
function render(cart) {

  let html = '';
  let subtotal = 0;

  let hasTrigger = false;

  if (CROSS_PROMO.enabled && CROSS_PROMO.triggerId) {
    hasTrigger = cart.items.some(
      item => Number(item.product_id) === Number(CROSS_PROMO.triggerId)
    );
  }

  if (!cart.items.length) {
    $content.html('<p class="empty-cart">Tu bolsa está vacía</p>');
    $subtotal.text(formatMoney(0));
    $cartCount.text(0);
    return;
  }

  cart.items.forEach(item => {

    const isGift =
      item.properties &&
      item.properties._free_gift === 'true';

    let linePrice = item.final_line_price;

    let isDiscounted = false;
    let discountedPrice = item.final_line_price;

    if (
      CROSS_PROMO.enabled &&
      hasTrigger &&
      !isGift &&
      CROSS_PROMO.conditionalIds.map(Number).includes(Number(item.product_id))
    ) {

      isDiscounted = true;

      const discountAmount =
        item.final_line_price *
        (CROSS_PROMO.discount / 100);

      discountedPrice = Math.round(
        item.final_line_price - discountAmount
      );

      linePrice = discountedPrice;
    }

    subtotal += linePrice;

    html += `
      <div class="flying-cart__item" data-key="${item.key}">

        <div class="flying-cart__thumb">
          <img src="${item.image}" alt="${item.product_title}">
        </div>

        <div class="flying-cart__info">

          <h5>${item.product_title}</h5>

          ${
            isGift
              ? `<div class="free-label">🎁 Producto de regalo</div>`
              : `
                <div class="flying-cart__qty">

                  <button class="qty-btn js-qty-minus">
                    <span class="icon_minus-06"></span>
                  </button>

                  <span class="qty">${item.quantity}</span>

                  <button class="qty-btn js-qty-plus">
                    <span class="icon_plus"></span>
                  </button>

                </div>
              `
          }

          <div class="flying-cart__price">

            ${
              isGift
                ? 'Gratis 🎁'
                : isDiscounted
                  ? `
                    <span style="text-decoration:line-through;opacity:.6;">
                      ${formatMoney(item.final_line_price)}
                    </span>

                    <span style="color:#28a745;margin-left:5px;">
                      ${formatMoney(discountedPrice)}
                    </span>
                  `
                  : formatMoney(item.final_line_price)
            }

          </div>

        </div>

        ${
          isGift
            ? ''
            : `
              <button class="flying-cart__remove js-remove-item">
                <span class="icon_trash_alt"></span>
              </button>
            `
        }

      </div>
    `;
  });

  $content.html(html);
  $subtotal.text(formatMoney(subtotal));
  $cartCount.text(cart.item_count);
}

/* =========================
   FETCH CART
========================= */
async function fetchCart(open = false) {

  const cart = await fetch('/cart.js')
    .then(r => r.json());

  cartState = cart;

  render(cart);

  await handleFreeGift(cart);

  const updatedCart = await fetch('/cart.js')
    .then(r => r.json());

  cartState = updatedCart;

  render(updatedCart);

  if (open) {
    openCart();
  }

  return updatedCart;
}

/* =========================
   SYNC CART STATE
========================= */
async function syncCartState() {

  if (syncing) return cartState;

  syncing = true;

  try {

    const cart = await fetch('/cart.js')
      .then(r => r.json());

    cartState = cart;

    await handleFreeGift(cart);

    const updatedCart = await fetch('/cart.js')
      .then(r => r.json());

    cartState = updatedCart;

    render(updatedCart);

    return updatedCart;

  } catch (e) {

    console.error('Cart sync error:', e);

    return cartState;

  } finally {

    syncing = false;
  }
}

/* =========================
   CART EVENTS
========================= */

$(document).on('click', '.js-remove-item', async function () {

  if (!cartState) return;

  const key = $(this)
    .closest('.flying-cart__item')
    .data('key');

  if (!key) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });

  await fetchCart();
});

$(document).on('click', '.js-qty-plus', async function () {

  const key = $(this)
    .closest('.flying-cart__item')
    .data('key');

  const item = cartState.items.find(i => i.key === key);

  if (!item) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: item.quantity + 1
    })
  });

  await fetchCart();
});

$(document).on('click', '.js-qty-minus', async function () {

  const key = $(this)
    .closest('.flying-cart__item')
    .data('key');

  const item = cartState.items.find(i => i.key === key);

  if (!item || item.quantity <= 1) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: item.quantity - 1
    })
  });

  await fetchCart();
});

/* =========================
   OPEN / CLOSE CART
========================= */

$(document).on('click', '#open-flying-cart', async e => {
  e.preventDefault();
  await fetchCart(true);
});

$(document).on(
  'click',
  '#flying-cart-overlay, .flying-cart__close',
  function () {
    closeCart();
  }
);

/* =========================
   ADD TO CART
========================= */

$(document).on('click', '.js-add-to-cart', async function (e) {

  e.preventDefault();

  if (syncing) return;

  const variantId = $(this).data('variant-id');

  if (!variantId) return;

  const isPromo =
    $(this).data('promo-tag') === cfg.triggerTag;

  const qty =
    Number($('input[name="quantity"]').val()) || 1;

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: qty,
      properties: isPromo
        ? { _promo_tag: cfg.triggerTag }
        : {}
    })
  });

  await fetchCart(true);
});

/* =========================
   FREE GIFT LOGIC (ahora en snippets)
========================= */


/* =========================
   CHECKOUT SYNC
========================= */

$(document).on(
  'click',
  '#flying-cart-checkout',
  async function (e) {

    e.preventDefault();

    if (syncing) return;

    const cart = await syncCartState();

    /* =========================
       CROSS PROMO CHECK
    ========================= */

    const promo = window.CROSS_PROMO || {};

    if (
      promo.enabled &&
      promo.triggerId &&
      promo.conditionalIds?.length
    ) {

      const hasTrigger = cart.items.some(
        i =>
          Number(i.product_id) ===
          Number(promo.triggerId)
      );

      const hasConditional = cart.items.some(
        i =>
          promo.conditionalIds
            .map(Number)
            .includes(Number(i.product_id))
      );

      if (hasTrigger && hasConditional) {

        const discountCode = '2ZKWR6F20WNE';

        window.location.href =
          `/discount/${discountCode}?redirect=/checkout`;

        return;
      }
    }

    window.location.href = '/checkout';
  }
);

/*modals */

/* modal traking*/
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-open-tracking-modal');
  if (!btn) return;

  e.preventDefault();

  const modalEl = document.getElementById('popUp');
  if (!modalEl) {
    console.warn('Modal #popUp no existe en el DOM');
    return;
  }

  let modal = bootstrap.Modal.getInstance(modalEl);
  if (!modal) {
    modal = new bootstrap.Modal(modalEl, {
      backdrop: true,
      focus: true,
      keyboard: true
    });
  }

  modal.show();
});


function handleTrackingSubmit() {
  const code = document.getElementById('myText')?.value.trim();
  if (!code) return;

  const url =
    'https://api.enviame.io/s2/companies/4312/deliveries/' +
    code +
    '/tracking';

  window.open(url, '_blank', 'noopener,noreferrer');
}

$(document).on('click', '#trackingSubmit', function () {
  handleTrackingSubmit();
});

$(document).on('keydown', '#myText', function (e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    handleTrackingSubmit();
  }
});

$(document).on('shown.bs.modal', '#popUp', function () {
  $('#myText').trigger('focus');
});


/*promos popup*/

document.addEventListener('DOMContentLoaded', function () {
  const modalEl = document.getElementById('imageModal');
  if (!modalEl || typeof bootstrap === 'undefined') return;

  const cookieName = 'promoModalShown';

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='));
  }

  function setCookie(name, value, hours) {
    const d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    document.cookie =
      name + '=' + value + '; expires=' + d.toUTCString() + '; path=/';
  }

  if (!getCookie(cookieName)) {
    setTimeout(() => {
      const modal = new bootstrap.Modal(modalEl);
      modal.show();
      setCookie(cookieName, 'true', 3); // 3 horas
    }, 4000);
  }
});

/* =========================
   SEARCH MODAL
========================= */

$(document).on('click', '.search-switch', function (e) {
  e.preventDefault();
  $('.search-model').addClass('active');
  setTimeout(function () {
    $('.search-model-form input').focus();
  }, 200);
});

$(document).on('click', '.search-close-switch', function () {
  $('.search-model').removeClass('active');
});

// Cerrar con ESC
$(document).on('keydown', function (e) {
  if (e.key === 'Escape') {
    $('.search-model').removeClass('active');
  }
});


/* =========================
   STICKY HEADER DESKTOP
========================= */

(function () {
  const sticky = document.getElementById('sticky-header');
  if (!sticky) return;

  let lastScroll = 0;

  window.addEventListener('scroll', function () {
    if (window.innerWidth < 992) return; // solo desktop

    const current = window.scrollY;

    if (current > 300) {
      sticky.classList.add('active');
    } else {
      sticky.classList.remove('active');
    }

    lastScroll = current;
  });
})();

/* =========================
   SHOP FILTERS
========================= */

function applyShopFilters() {
  const activeCollections = [];
  document.querySelectorAll('.js-filter-collection:checked').forEach(cb => {
    activeCollections.push(cb.value);
  });

  const minPrice = parseFloat(document.getElementById('price-min')?.value || 0);
  const maxPrice = parseFloat(document.getElementById('price-max')?.value || Infinity);

  document.querySelectorAll('.shop-product-item').forEach(item => {
    const price = parseFloat(item.dataset.price);
    const collections = item.dataset.collections;

    let visible = true;

    // Filtro colección
    if (activeCollections.length) {
      let match = false;
      activeCollections.forEach(c => {
        if (collections.includes(c)) match = true;
      });
      if (!match) visible = false;
    }

    // Filtro precio
    if (price < minPrice || price > maxPrice) {
      visible = false;
    }

    item.style.display = visible ? '' : 'none';
  });
}

document.addEventListener('change', function (e) {
  if (e.target.classList.contains('js-filter-collection')) {
    applyShopFilters();
  }
});

document.addEventListener('click', function (e) {
  if (e.target.id === 'apply-price-filter') {
    e.preventDefault();
    applyShopFilters();
  }
});

/* =========================
   LIVE COLLECTION FILTER
========================= */

function applyLiveFilters() {
  const activeFilters = Array.from(
    document.querySelectorAll('.js-filter-collection:checked')
  ).map(el => el.value);

  const cards = document.querySelectorAll('.product-card');

  // Si no hay filtros → mostrar todo
  if (activeFilters.length === 0) {
    cards.forEach(card => {
      card.style.display = '';
    });
    return;
  }

  cards.forEach(card => {
    const collections = card.dataset.collections
      ? card.dataset.collections.split(',')
      : [];

    const match = activeFilters.some(f => collections.includes(f));

    card.style.display = match ? '' : 'none';
  });
}

// Escuchar cambios
document.addEventListener('change', function (e) {
  if (e.target.classList.contains('js-filter-collection')) {
    applyLiveFilters();
  }
});

/* =========================
   WHATSAPP FLOAT PRO (FINAL)
========================= */
document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('whatsapp-float');
  if (!el) return;

  const phone = el.dataset.phone;
  const productTitle = el.dataset.productTitle || '';

  const startHour = parseInt(el.dataset.startHour, 10);
  const endHour = parseInt(el.dataset.endHour, 10);

  const now = new Date();
  const hour = now.getHours();

  // ⏰ Horario de atención
  if (!isNaN(startHour) && !isNaN(endHour)) {
    if (hour < startHour || hour >= endHour) {
      el.style.display = 'none';
      return;
    }
  }

  const btn = el.querySelector('.whatsapp-button');
  if (!btn) return;

  btn.addEventListener('click', function (e) {
    e.preventDefault();

    let message = 'Hola, quiero hacer una consulta 😊';

    if (productTitle) {
      message = 'Hola, necesito información del producto ' + productTitle;
    }

    const url =
      'https://wa.me/' +
      phone.replace(/\D/g, '') +
      '?text=' +
      encodeURIComponent(message);

    window.open(url, '_blank', 'noopener');
  });
});

/* =========================
   ADD TO CART TRACKING
========================= */

$(document).on('click', '.js-add-to-cart', function () {

  if (!window.dataLayer) return;

  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: Shopify.currency.active,
      items: [{
        item_id: $(this).data('product-id'),
        item_name: $(this).data('product-name'),
        price: Number($(this).data('product-price')),
        quantity: 1
      }]
    }
  });

});


/* =========================
   BEGIN CHECKOUT TRACKING
========================= */

$(document).on('click', '.btn-checkout', function () {

  if (!window.dataLayer || !window.cartState) return;

  dataLayer.push({
    event: 'begin_checkout',
    ecommerce: {
      currency: Shopify.currency.active,
      value: cartState.total_price / 100,
      items: cartState.items.map(item => ({
        item_id: item.product_id,
        item_name: item.product_title,
        price: item.final_price / 100,
        quantity: item.quantity
      }))
    }
  });

});

/* botón checkout comunas*/
document.addEventListener('click', function(e) {

  const btn = e.target.closest('.flying-cart-checkout');
  if (!btn) return;

  e.preventDefault();

  const flyingCart = document.getElementById('flying-cart');
  if (!flyingCart) {
    window.location.href = '/checkout';
    return;
  }

  const region = flyingCart.querySelector('#fields-select__region');
  const town   = flyingCart.querySelector('#fields-select__town');

  // Si no existen, simplemente ir a checkout
  if (!region || !town) {
    window.location.href = '/checkout';
    return;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/cart';

  const checkoutInput = document.createElement('input');
  checkoutInput.type = 'hidden';
  checkoutInput.name = 'checkout';
  checkoutInput.value = 'true';
  form.appendChild(checkoutInput);

  const regionInput = document.createElement('input');
  regionInput.type = 'hidden';
  regionInput.name = 'attributes[Región]';
  regionInput.value = region.value;
  form.appendChild(regionInput);

  const townInput = document.createElement('input');
  townInput.type = 'hidden';
  townInput.name = 'attributes[Comuna]';
  townInput.value = town.value;
  form.appendChild(townInput);

  document.body.appendChild(form);
  form.submit();

});

/* VALIDADOR REGION / COMUNA DRAWER */

function validateDrawer() {

  const btn = document.querySelector('#flying-cart-checkout');
  const region = document.querySelector('#fields-select__region-drawer');
  const town = document.querySelector('#fields-select__town-drawer');

  if (!btn || !region || !town) return;

  const regionValid =
    region.value &&
    region.value !== 'Selecciona tu Región' &&
    region.value !== 'Región';

  const townValid =
    town.value &&
    town.value !== 'Selecciona tu comuna' &&
    town.value !== 'Comuna';

  if (regionValid && townValid) {
    btn.disabled = false;
  } else {
    btn.disabled = true;
  }

}

/* escuchar cambios */

document.addEventListener('change', function(e){

  if(
    e.target.id === 'fields-select__region-drawer' ||
    e.target.id === 'fields-select__town-drawer'
  ){
    validateDrawer();
  }

});

/* correr cuando cargue el drawer */

setInterval(validateDrawer, 500);

document.querySelectorAll('.categories__video').forEach(video => {
  video.play().catch(() => {
    video.muted = true;
    video.play();
  });
});


$(document).on('click', '#flying-cart-checkout', function(e) {

  if (!cartState) return;

  const promo = window.CROSS_PROMO || {};

  // 🔒 si está desactivado → NO tocar nada
  if (!promo.enabled) return;

  const triggerId = Number(promo.triggerId);
  const conditionalIds = (promo.conditionalIds || []).map(Number);

  const hasTrigger = cartState.items.some(i => Number(i.product_id) === triggerId);

  const hasConditional = cartState.items.some(i =>
    conditionalIds.includes(Number(i.product_id))
  );

  // 🚫 NO cumple → salir sin tocar el evento
  if (!hasTrigger || !hasConditional) return;

  // ✅ SOLO AQUÍ intercepta
  e.preventDefault();

  const discountCode = '2ZKWR6F20WNE';

  window.location.href = `/discount/${discountCode}?redirect=/checkout`;
});

function clearDiscountIfInvalid() {
  if (!cartState || !window.CROSS_PROMO) return;

  const promo = window.CROSS_PROMO;

  if (!promo.enabled) {
    fetch('/discount/').then(() => {});
    return;
  }

  const hasTrigger = cartState.items.some(i => i.product_id == promo.triggerId);

  const hasConditional = cartState.items.some(i =>
    promo.conditionalIds.includes(i.product_id)
  );

  if (!hasTrigger || !hasConditional) {
    fetch('/discount/').then(() => {});
  }
}



})(jQuery);
